export default __webpack_public_path__ + "static/flipImg1-8956a42dac60078e43e020e725a0ffea.webp";